export default __webpack_public_path__ + "static/media/mandakki_puri.b1af3dfa.png";